<template>
  <v-container fluid class="login ma-0 pa-0">
    <v-row class="ma-0 pa-0" no-gutters>
      <v-col class="ma-0 pa-0" style="height: 100vh; overflow-y: hidden" cols="12" md="6">
        <v-img class="login-img" src="../assets/login.png" :min-height="windowSize.height">
          <div
            class="d-flex flex-column justify-center"
            :style="$vuetify.breakpoint.smAndDown ? '' : 'margin-top: 30vh;'"
          >
            <img src="../assets/ellipse-login.svg" />
            <span
              class="font-weight-medium"
              :class="$vuetify.breakpoint.smAndDown ? 'body-1' : 'display-1'"
              style="color: #f8fcff; text-shadow: 0px 2px 2px #45459a89; text-align: center"
              >Personalized Online Classes</span
            >
            <img src="../assets/ellipse-login.svg" />
          </div>
        </v-img>
      </v-col>
      <router-view
        :class="$vuetify.breakpoint.smAndDown ? 'absolute full-height' : ''"
      ></router-view>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Auth",
  components: {},
  data: () => ({
    windowSize: {
      width: 0,
      height: 0,
    },
  }),
  mounted() {
    this.onResize();
  },
  methods: {
    onResize() {
      this.windowSize = {
        width: window.innerWidth,
        height: window.innerHeight,
      };
    },
  },
};
</script>
<style>
.login .login-img {
  background: transparent linear-gradient(180deg, #0000ca54 0%, #00cdf924 100%) 0% 0% no-repeat
    padding-box;
}
.login .login-img .v-image__image {
  mix-blend-mode: soft-light;
}
div.container.login {
  background: #f8fcff;
}
.full-height {
  height: 100vh;
}
</style>
